import { obfuscate, tryDecode } from '@siza-staff-care/shared/data';
import { DateTime } from 'luxon';
import { ensureDateTime } from './time-utils';

export const qsDateTime = (value: Date | DateTime | undefined | null, allowEmpty = false): string | null => {
	if (!value) {
		return allowEmpty ? '' : null;
	}

	return encodeURIComponent(ensureDateTime(value).toISODate());
};

export const qsOid = (oid: string | undefined | null): string | null => {
	if (!oid) {
		return null;
	}

	const obfuscated = obfuscate(oid);
	return encodeURIComponent(obfuscated);
};

export const fromQsOid = (oid: string | undefined | null): string | null => {
	if (!oid) {
		return null;
	}

	return tryDecode(oid);
};

export const fromQsDateTime = (value: string | null | undefined): Date | undefined => {
	if (!value) {
		return undefined;
	}
	return DateTime.fromISO(value).toJSDate();
};

export const fromQsBool = (value: string | null | undefined): boolean => {
	if (!value) {
		return false;
	}
	return value === 'true';
};
